import { CreateVisitorTypes } from "../../../../../reduxToolkit/VisitorTypes/VisitorTypesApi";
import { toast } from "react-toastify";
import {errorMsg} from "../../../../../Apis/functions";
import {CUSTOM_FIELD_MODEL} from "../Model/Model";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer
 *
 * Custom hook to handle the creation of a visitor type.
 * Includes validation, API integration, user feedback, and navigation.
 *
 * @param {function} t - Translation function from i18next.
 * @param {function} dispatch - Redux dispatch function.
 * @param {object} item - Visitor type model data.
 * @param {Array} fields - List of custom fields.
 * @param {function} setFieldData - Setter for custom field model state.
 * @param {function} setEmptyFields - Setter for empty fields validation flag.
 * @param {function} reset - Function to reset form state.
 * @param {function} handleOnBack - Callback to handle navigation back.
 *
 * @returns {object} An object containing the handleCreate function.
 */
const CreateVisitorTypeApp = ({
                                  t,
                                  dispatch,
                                  item,
                                  fields,
                                  setFieldData,
                                  setEmptyFields,
                                  reset,
                                  handleOnBack
                              }) => {
    /**
     * Handles the creation of a visitor type.
     * - Validates input data and custom fields.
     * - Dispatches API request.
     * - Displays success or error feedback.
     * - Navigates back on success.
     */
    const handleCreate = () => {

        // Validate visitor type data
        if (!item.isValid()) {
            setEmptyFields(true);
            return;
        }
        // Validate almost one custom fields
        if(!item.isValidFields(fields)){
            setEmptyFields(true);
            toast.warning(t("add_at_least_one_custom_field"));
            return;
        }
        setEmptyFields(false);
        // Send API request to create visitor type
        dispatch(CreateVisitorTypes(item.toRegister(fields))).then(({ payload: { data } }) => {
            if (data?.success) {
                // Reset custom field state
                setFieldData({ ...CUSTOM_FIELD_MODEL });
                // On success: reset form, navigate back, show success message
                reset();
                handleOnBack();
                toast.success(t('has_been_created_successfully'));
            } else {
                // On error: show translated error message if available
                errorMsg(data.code);
            }
        });
    };

    // Return the handler to be used by the consuming component
    return {
        handleCreate
    };
};

export default CreateVisitorTypeApp;
